import { Divider, Tooltip, Typography } from 'antd';
import { ReactComponent as DeleteIcon } from 'assets/img/DeleteMaskIcon.svg';
import { ReactComponent as EditMaskIcon } from 'assets/img/EditMaskIcon.svg';
import { ReactComponent as Tick } from 'assets/img/icons/GreenDropdownTick.svg';
import VerticalDivider from 'assets/svgs/VerticalDivider';
import Checkbox from 'modules/Common/Components/Checkbox';
import GlobalAntButton from 'modules/Common/Components/GlobalAntButton';
import GlobalInput from 'modules/Common/Components/GlobalInputs';
import styled from 'styled-components';
import { IActionData, IFieldDataTemp } from '../interfaces';
import { useEffect, useState } from 'react';
import { formats, internalFields } from '../constants';
import classNames from 'classnames';
import SelectAnt from '../Components/SelectAnt';
const { Text } = Typography;

const commonCSS = {
  flex: '1',
  fontSize: '18px',
  fontWeight: '500',
  fontFamily: 'Roboto',
  lineHeight: '21.09px',
  color: '#5E7079',
  gap: '16px',
};

const MappingHeader = styled.div`
  display: flex;
  margin: 12px 0;
  @media all and (max-width: 1439px) {
    font-size: 16px !important;
  }
  ${commonCSS};
`;
const ExternalField = styled.div`
  width: 100%;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-aspect-ratio: 1.25) {
    font-size: 15px !important;
  }
  ${commonCSS}
`;
const InternalField = styled.div`
  width: 100%;
  z-index: 1;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-aspect-ratio: 1.25) {
    font-size: 15px !important;
  }
  .optionActive {
    color: #1ec252;
  }
  .css-1uxsi1k-menu :first-child {
    max-height: 130px !important;
  }
  ${commonCSS}
`;
const DataFormat = styled.div`
  width: 100%;
  z-index: 1;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-aspect-ratio: 1.25) {
    font-size: 15px !important;
  }
  .css-1uxsi1k-menu :first-child {
    max-height: 130px !important;
  }
  ${commonCSS}
`;
const Required = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  @media all and (max-width: 1366px) {
    flex: 1% !important;
    /* flex: 2% !important; */
  }
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-aspect-ratio: 1.25) {
    font-size: 15px !important;
  }
  @media all and (min-width: 1024px) and (max-width: 1152px) {
    flex: 1% !important;
    /* flex: 14% !important; */
  }
  @media all and (min-width: 1153px) and (max-width: 1260px) {
    flex: 1% !important;
    /* flex: 6% !important; */
  }
  ${commonCSS}
`;
const MappingBody = styled.div`
  display: flex;
  align-items: center;
  .select-form-input span.ant-select-selection-item {
    color: #7e7e7e !important;
    font-family: 'Roboto' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 20px !important;
    letter-spacing: -0.4px !important;
    @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px !important;
    }
  }
  .vertical-divider {
    margin: 0 6px;
    stroke-width: 1px !important;
    stroke: #ddd !important;
  }
  .checkbox-wrapper {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 4.5em !important;
    margin-right: 0 !important;
  }
  .checkbox-wrapper label span {
    width: 19px !important;
    height: 19px !important;
  }
  ${commonCSS};
`;
const HelpingText = styled.div`
  font-family: 'Roboto';
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.3999999761581421px;
  text-align: left;
  color: #7e7e7e;
  margin-top: 8px;
`;

const Mapping = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
`;
const MappingTitle = styled.p`
  font-size: 16px;
  width: 89%;
  margin: 0;
  font-weight: 500;
  color: #7e7e7e;
  line-height: 20px;
  font-family: 'Roboto';
`;
type Props = {
  field: IFieldDataTemp;
  fieldIndex: number;
  onChangeFieldValue: (val: string | boolean, index: number, prop: keyof IFieldDataTemp) => void;
  deleteFieldMapping: (index: number) => void;
  disableAddField: boolean;
  setDisableAddField: (val: boolean) => void;
  checkCreateFormButton: () => void;
  setisOpenDeletePopup: (val: boolean) => void;
  setTempObj: (obj: { index: number; isAction: boolean; action?: IActionData }) => void;
  isDisableOnFieldChanged: boolean;
  setIsDisableOnFieldChanged: (val: boolean) => void;
  setDefaultFieldValue: (index: number, field: IFieldDataTemp) => void;
};

const CreateFormMapping = (props: Props) => {
  // Props destructuring
  const {
    field,
    fieldIndex,
    onChangeFieldValue,
    deleteFieldMapping,
    disableAddField,
    setDisableAddField,
    checkCreateFormButton,
    setisOpenDeletePopup,
    setTempObj,
    isDisableOnFieldChanged,
    setIsDisableOnFieldChanged,
    setDefaultFieldValue,
  } = props;

  // Local states
  const [onFieldEdit, setOnFieldEdit] = useState(false);
  const [onClickSave, setOnClickSave] = useState(false);
  const [tempField, setTempField] = useState(field);

  // Functions
  const optionsConverter = (options: { label: string; value: string }[], value: string) => {
    const newOptions = options.map((field) => {
      const isSelectedOption = field.value === value;
      return {
        value: field.value,
        label: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>
              <Tick style={{ opacity: `${isSelectedOption ? '1' : '0'}` }} />
            </span>
            <span style={{ marginLeft: '9px' }}>
              <Tooltip title={field.value}>
                <Text
                  className={classNames('form-ellipse-title', { optionActive: isSelectedOption })}
                  style={{ width: 'calc(100vw - 91vw)' }}
                  ellipsis={{ tooltip: field.value }}
                >
                  {field.value}
                </Text>
              </Tooltip>
            </span>
          </div>
        ),
      };
    });
    return newOptions;
  };

  // Local Variables
  const externalFieldValue = field?.externalField;
  const internalFieldValue = field?.internalField;
  const dataFormatValue = field?.dataFormat;
  const isRequiredValue = field?.isRequired;
  const isSavedValue = field?.isSaved;
  const optionsDataFormat = optionsConverter(formats, dataFormatValue);
  const optionsInternalFields = optionsConverter(internalFields, internalFieldValue);

  // useEffect
  useEffect(() => {
    if (onClickSave) {
      setTempField(field);
    }
  }, [onClickSave]);

  // Functions
  const handleInternalFieldChange = (value: string) => {
    onChangeFieldValue(value, fieldIndex, 'internalField');
  };
  const handleDataFieldChange = (value: string) => {
    onChangeFieldValue(value, fieldIndex, 'dataFormat');
  };

  return (
    <>
      {!field?.isSaved ? (
        <>
          <div style={{ display: 'flex', flexFlow: 'column' }} className="mapping-section">
            <MappingHeader>
              <ExternalField>{fieldIndex + 1}-External Field*</ExternalField>
              <InternalField>Internal Field*</InternalField>
              <InternalField></InternalField>
              {/* <DataFormat>Data format*</DataFormat>
              <Required>Required</Required> */}
              {/* <Empty></Empty> */}
            </MappingHeader>
          </div>
          <MappingBody>
            <ExternalField>
              <GlobalInput
                width=""
                size={'large'}
                placeholder={'First Name'}
                prefix={''}
                padding=""
                value={externalFieldValue}
                handleInputChange={(e) => onChangeFieldValue(e.target.value, fieldIndex, 'externalField')}
                onPressEnter={() => {}}
                bgColor={''}
                border={''}
                color={''}
                borderRadius={'8px'}
                suffix={''}
                inputType={'input'}
              />
            </ExternalField>
            <InternalField>
              <SelectAnt
                defaultValue={{ value: 'First Name', label: 'First Name' }}
                options={optionsInternalFields}
                onChange={handleInternalFieldChange}
                disabled={false}
                value={{ value: internalFieldValue, label: internalFieldValue }}
              />
            </InternalField>
            {/* <DataFormat>
              <SelectAnt
                defaultValue={{ value: 'Text', label: 'Text' }}
                options={optionsDataFormat}
                onChange={handleDataFieldChange}
                disabled={false}
                value={{ value: dataFormatValue, label: dataFormatValue }}
              />
            </DataFormat> */}
            <Required>
              {/* <Checkbox
                checked={isRequiredValue}
                className="required-checkbox"
                onChange={(e: any) => onChangeFieldValue(e.target.checked, fieldIndex, 'isRequired')}
              /> */}
              <div style={{ display: 'flex', gap: 8 }}>
                <GlobalAntButton
                  maxWidth="91px"
                  btnText={'Cancel'}
                  disabled={false}
                  onClick={() => {
                    if (onFieldEdit) {
                      // Setting default value of field
                      setDefaultFieldValue(fieldIndex, tempField);
                    } else {
                      // Deletes the field
                      deleteFieldMapping(fieldIndex);
                    }
                    setDisableAddField(false);
                    setIsDisableOnFieldChanged(false);
                  }}
                  border={'1px solid #979797'}
                  padding={''}
                  bgColor={'#fff'}
                  color={'#979797'}
                  customIcon={''}
                  borderRadius={'20px'}
                  fontSize={'16px'}
                  boxShadow={''}
                  icon={''}
                  buttonType={'type'}
                  btnType={'default'}
                  loading={false}
                  width={'91px'}
                />
                <GlobalAntButton
                  maxWidth="91px"
                  btnText={'Save'}
                  disabled={externalFieldValue?.trim()?.length === 0 || isDisableOnFieldChanged}
                  onClick={() => {
                    // a check to keep track and update the temp Field
                    setOnClickSave(true);
                    // Save field + Ui changes
                    onChangeFieldValue(true, fieldIndex, 'isSaved');
                    setDisableAddField(false);
                    checkCreateFormButton();
                  }}
                  border={'none'}
                  padding={''}
                  bgColor={'#1EC252'}
                  color={'#fff'}
                  customIcon={''}
                  borderRadius={'20px'}
                  fontSize={'16px'}
                  boxShadow={''}
                  icon={''}
                  buttonType={'type'}
                  btnType={'default'}
                  loading={false}
                  width={'91px'}
                />
              </div>
            </Required>
          </MappingBody>
          <HelpingText>Enter the website form field element precisely.</HelpingText>
        </>
      ) : (
        <div>
          <Mapping>
            <MappingTitle>
              {fieldIndex + 1}-External Field: "{externalFieldValue}" will map to Internal Field: "{internalFieldValue}"
              {/* {isRequiredValue && <span style={{ fontStyle: 'italic', fontWeight: '400' }}>(Required)</span>} */}
            </MappingTitle>
            <span id="icons">
              <span
                className={classNames('field-edit-icon', { disabled: isSavedValue && disableAddField })}
                onClick={() => {
                  onChangeFieldValue(false, fieldIndex, 'isSaved');
                  setIsDisableOnFieldChanged(true);
                  setDisableAddField(true);
                  setOnFieldEdit(true);
                }}
              >
                <EditMaskIcon style={{ cursor: 'pointer' }} />
              </span>
              <VerticalDivider />
              <span
                className="field-delete-icon"
                onClick={() => {
                  setisOpenDeletePopup(true);
                  setTempObj({ index: fieldIndex, isAction: false });
                }}
              >
                <DeleteIcon style={{ cursor: 'pointer' }} />
              </span>
            </span>
          </Mapping>
          <Divider style={{ margin: '0' }} />
        </div>
      )}
    </>
  );
};

export default CreateFormMapping;
